import { RecentlyViewed } from 'src/common-services/types/recently-viewed'
import { BaseClient } from 'src/common-services/clients/base-client'
import { RecentlyViewedRequest, UserList } from 'src/common-services/types/user-lists-types'

export class RecentlyViewedClient extends BaseClient {
  addRecentlyViewed(request: RecentlyViewed): Promise<void> {
    return this.call('/recently-viewed', 'PUT', { data: request })
  }

  getRecentlyViewed(request?: RecentlyViewedRequest): Promise<UserList> {
    const params = request ? { types: request.types?.join(','), limit: request.limit } : undefined
    return this.call<UserList>('/recently-viewed', 'GET', { params })
  }

  deleteRecentlyViewed(itemId: string): Promise<void> {
    return this.call<void>(`/recently-viewed/${itemId}`, 'DELETE')
  }

  deleteAllRecentlyViewed(): Promise<void> {
    return this.call<void>(`/recently-viewed/`, 'DELETE')
  }
}
